import api, { handleApiError } from './api';

// Alle Läden abrufen
export const getStores = async () => {
  try {
    const response = await api.get('/stores');
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

// Einzelnen Laden abrufen
export const getStore = async (id) => {
  try {
    const response = await api.get(`/stores/${id}`);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

// Laden erstellen
export const createStore = async (name) => {
  try {
    const response = await api.post('/stores', { name });
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

// Laden bearbeiten
export const updateStore = async (id, name) => {
  try {
    const response = await api.put(`/stores/${id}`, { name });
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

// Laden löschen
export const deleteStore = async (id) => {
  try {
    const response = await api.delete(`/stores/${id}`);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

// Artikel mit Positionen für einen Laden abrufen (für Sortier-Screen)
export const getStoreArticles = async (storeId) => {
  try {
    const response = await api.get(`/stores/${storeId}/articles`);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

// Positionen mehrerer Artikel für einen Laden aktualisieren (für Drag&Drop)
export const updateStoreArticlePositions = async (storeId, articles) => {
  try {
    const response = await api.put(`/stores/${storeId}/articles/positions`, { articles });
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

// Artikel-Position für einen Laden löschen (Artikel aus Sortierliste entfernen)
export const deleteStoreArticlePosition = async (storeId, articleId) => {
  try {
    const response = await api.delete(`/stores/${storeId}/articles/${articleId}`);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

